<template>
  <div class="EvisionSignupPage">
    <div>
      <div v-show="ui.step === 0">
        <h2 class="primary--text text-center mb-4">Bienvenue !</h2>
        <p>Nous vous proposons ce nouveau service, vous permettant de :</p>
        <ul>
          <li>
            Demander un rdv avec un conseiller optique dans le magasin de votre choix (qui vous sera confirmé par votre opticien par
            téléphone)
          </li>
          <li>Echanger des messages et des documents</li>
          <li>Accéder à des informations et des conseils de prévention concernant votre vue</li>
        </ul>
        <v-btn block rounded class="primary mt-4" @click="ui.step++">Je prends rendez-vous </v-btn>
        <div class="mt-4" style="text-align: center">
          <router-link :to="{ name: 'auth@login' }">J'ai déjà un compte</router-link>
        </div>
      </div>

      <div v-show="ui.step === 1">
        <IriadeSelect
          :items="teams.map((t) => ({ text: t.name, value: t.id }))"
          v-model="team_id"
          label="Magasin"
          @input="tryGetAvailableAppointmentsSlots"
        ></IriadeSelect>
        <div v-if="team_id">
          <IriadeSelect
            :items="appointmentTypes.map((a) => ({ text: a.label, value: a.id }))"
            v-model="type_id"
            label="Type de rendez-vous"
            @input="tryGetAvailableAppointmentsSlots"
          ></IriadeSelect>
          <div v-if="type_id">
            <v-btn block text @click="previousSlotsDays" :disabled="firstSlotDayIsToday">
              <v-icon>keyboard_arrow_up</v-icon>
            </v-btn>
            <v-expansion-panels>
              <v-expansion-panel v-for="(day, idx) in ui.slotsDays" :key="idx">
                <v-expansion-panel-header>
                  <div style="text-transform: capitalize">
                    {{ day | moment("dddd DD/MM") }}
                    <span v-if="appointmentSlots[day]">
                      <v-chip class="primary ml-2">{{ Object.keys(appointmentSlots[day]).length }}</v-chip>
                    </span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <div v-if="appointmentSlots[day]">
                        <v-btn
                          v-for="slot in appointmentSlots[day]"
                          block
                          class="primary mb-3"
                          :key="slot[0]"
                          @click="
                            setAppointmentDatetime(day, slot);
                            ui.showConfirmAppointmentModal = true;
                          "
                          >{{ slot[0] }} - {{ slot[1] | remove15Minutes }}
                        </v-btn>
                      </div>
                      <div v-if="!appointmentSlots[day]">
                        <p>Aucune disponibilité ce jour.</p>
                        <v-btn class="primary" block @click="ui.showNewSlotRequiredModal = true">Demander un créneau </v-btn>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-btn block text :disabled="disabledLastArrow" @click="nextSlotsDays">
              <v-icon>keyboard_arrow_down</v-icon>
            </v-btn>
          </div>
        </div>

        <IriadeSettingsDialog :show="ui.showNewSlotRequiredModal">
          <v-card>
            <v-card-title class="headline primary white--text">Demander un créneau</v-card-title>
            <v-card-text class="pt-4">
              <p>
                Souhaitez-vous demander un rendez-vous en dehors des créneaux disponibles ? Indiquez-nous vos disponibilités et nous vous
                recontacterons pour convenir d'un rendez-vous avez vous.
              </p>
              <IriadeTextarea label="Disponibilités" v-model="new_slot_required_message"></IriadeTextarea>
            </v-card-text>
            <v-card-actions style="display: flex; justify-content: flex-end">
              <v-btn text @click="ui.showNewSlotRequiredModal = false">Annuler </v-btn>
              <v-btn
                class="primary"
                @click="
                  ui.showNewSlotRequiredModal = false;
                  new_slot_required = true;
                  ui.step++;
                "
                >Confirmer
              </v-btn>
            </v-card-actions>
          </v-card>
        </IriadeSettingsDialog>

        <IriadeSettingsDialog :show="ui.showConfirmAppointmentModal">
          <v-card>
            <v-card-title class="headline primary white--text">Valider ce rendez-vous</v-card-title>
            <v-card-text class="pt-4"
              >Confirmez-vous la demande de rendez-vous le {{ appointment.day | moment("dddd DD/MM") }} de {{ appointment.slot[0] }} à
              {{ appointment.slot[1] | remove15Minutes }} ? Attention ! Le rendez-vous sera confirmé uniquement lorsque votre opticien aura
              pris contact avec vous.
            </v-card-text>
            <v-card-actions style="display: flex; justify-content: flex-end">
              <v-btn text @click="ui.showConfirmAppointmentModal = false">Annuler </v-btn>
              <v-btn
                class="primary"
                @click="
                  ui.showConfirmAppointmentModal = false;
                  ui.step++;
                "
                >Confirmer
              </v-btn>
            </v-card-actions>
          </v-card>
        </IriadeSettingsDialog>
      </div>

      <div v-show="ui.step === 2">
        <p>
          Votre demande de rendez-vous nécessite la création d'un compte et l'enregistrement de votre
          <span class="primary--text">consentement</span>.
        </p>
        <MangoCaption>Lisez attentivement les conditions d’utilisation du service Optique Viasanté ci-dessous :</MangoCaption>
        <p style="font-size: 12px; line-height: 1.2; border: 1px solid #eee; padding: 5px; max-height: 350px; overflow: scroll">
          Contrat de consentement – Optique Mutualiste VIASANTE – Service de prise de rdv en ligne   Le service de prise de rdv Optique
          Mutualiste VIASANTÉ s’adresse à toute personne souhaitant bénéficier de la prise de rdv en ligne. Le service ne doit être utilisé
          que par des personnes de plus de 18 ans.  La prise et le suivi de rdv est un service numérique édité par Optique Mutualiste
          VIASANTÉ 1 avenue Carsalade du Pont - BP 89921 - 66866 PERPIGNAN cedex 9. Le service est opéré par la société IRIADE SAS - 8
          avenue des tilleuls 31280 MONS - contact@iriade.fr, sur la solution logicielle en ligne Iriade Télésuivi. Les données collectées
          par Optique Mutualiste VIASANTÉ sont hébergées en France, par la société COREYE-PICTIME  50 rue Paradis, 75010 Paris, qui possède
          l’agrément HADS SILVER SANTE, obtenu auprès de l'ASIP Santé, pour l'hébergement des données de santé.  L’inscription au service se
          fait à l’initiative de l’utilisateur. Le service de prise de rdv Optique Mutualiste VIASANTÉ vous permet d’être mis en contact
          avec un conseiller optique dans la boutique de votre choix. Le service vous permet de demander un rendez-vous, d’échanger des
          messages et des documents, d’accéder à des médias d’information et de conseil, de constituer votre Dossier Optique. L’inscription
          au service de prise de rdv Optique Mutualiste VIASANTÉ vous donne accès à un espace personnel et confidentiel contenant les médias
          qui vous sont envoyés, vos messages personnels et vos données de profil (nom, prénom, numéro de téléphone, année de naissance).
          Votre inscription nécessite de pouvoir vous contacter par e-mail et SMS (aucune information personnelle n’est indiquée dans les
          e-mails et SMS). Il est aussi nécessaire de disposer d’un ordinateur, une tablette ou un smartphone, d’un accès à Internet et d’un
          navigateur web compatible avec l’application, pour bénéficier du service de prise de rdv Optique Mutualiste VIASANTÉ. Le service
          n’inclut pas la mise à disposition de ces dispositifs de communication. Les frais d’accès à Internet et de télécommunication ne
          sont pas pris en charge par Optique Mutualiste VIASANTÉ.  L’inscription au service de prise de rdv Optique Mutualiste VIASANTÉ
          nécessite votre consentement et votre validation (bouton « Oui je donne mon consentement » en bas de page) pour exprimer votre
          accord et confirmer que vous avez bien pris connaissance des conditions d’utilisation.  À l'occasion de l'utilisation du
          site optique-viasante.iriade.fr peuvent être recueillies : l'URL des liens par l'intermédiaire desquels l'utilisateur a accédé au
          site optique-viasante.iriade.fr, le fournisseur d'accès de l'utilisateur, l'adresse de protocole Internet (IP) de l'utilisateur.
          En tout état de cause Iriade ne collecte des informations personnelles relatives à l'utilisateur que pour le besoin de certains
          services proposés par le site optique-viasante.iriade.fr. Optique Mutualiste VIASANTE utilisera ces informations, le cas échéant,
          pour l’établissement du devis que doit fournir l’opticien dans le cadre de la convention passée entre lui et les organismes de
          régime obligatoire et la gestion de la demande de prise en charge par l’utilisateur. L'utilisateur fournit ces informations en
          toute connaissance de cause, notamment lorsqu'il procède par lui-même à leur saisie. Il est alors précisé à l'utilisateur du
          site optique-viasante.iriade.fr l’obligation ou non de fournir ces informations.  Vos données à caractère personnel sont
          collectées par Optique Mutualiste VIASANTÉ et traitées par IRIADE SAS dans le cadre de service de rdv. La collecte de noms,
          prénoms, adresse e-mail, téléphone et année de naissance sont nécessaires pour pouvoir bénéficier du service de rdv Optique
          VIASANTÉ. Les données personnelles collectées et traitées dans le cadre de l’inscription au service et des échanges avec votre
          conseiller sont strictement confidentielles.  Vos données pourront aussi être traitées à des fins statistiques pour améliorer nos
          prestations, ces données sont anonymisées et ne permettent pas votre identification. Vous disposez de différents droits dont celui
          de demander l’accès aux données vous concernant, leur rectification et leur effacement ou de vous opposer à la mise en œuvre d’un
          traitement. Les données à caractère personnel sont notamment protégées par la loi n°78-87 du 6 janvier 1978 modifiée et le
          Règlement Général sur la Protection des Données (RGPD) n°2016/679. Aucune information personnelle de l'utilisateur du
          site optique-viasante.iriade.fr n'est publiée à l'insu de l'utilisateur, échangée, transférée, cédée ou vendue sur un support
          quelconque à des tiers. Seule l'hypothèse du rachat de Iriade SAS et de ses droits permettrait la transmission des dites
          informations à l'éventuel acquéreur qui serait à son tour tenu de la même obligation de conservation et de modification des
          données vis-à-vis de l'utilisateur du site optique-viasante.iriade.fr.  Les bases de données sont protégées par les dispositions
          de la loi du 1er juillet 1998 transposant la directive 96/9 du 11 mars 1996 relative à la protection juridique des bases de
          données.
        </p>
        <v-checkbox v-model="consent_checkbox" label="Oui, je donne mon consentement"></v-checkbox>
        <v-btn block rounded class="primary my-4" :disabled="!consent_checkbox" @click="ui.step++">Continuer </v-btn>
      </div>

      <div v-show="ui.step === 3">
        <h3>Création de votre compte</h3>
        <v-alert class="mb-4 primary" :value="true" v-if="!new_slot_required">
          <h3 class="white--text">Votre rendez-vous</h3>
          <div class="white--text" v-if="appointment.day">
            {{ currentAppointmentTypeLabel }} Le {{ appointment.day | moment("L") }} de {{ appointment.slot[0] }} à
            {{ appointment.slot[1] | remove15Minutes }}
          </div>
        </v-alert>
        <MangoCaption
          >Pour profiter du suivi Optique Viasanté ainsi que des rappels de rendez-vous, veuillez renseigner les champs suivants.
        </MangoCaption>
        <IriadeTextInput label="Prénom" :error-messages="ui.errors.first_name" v-model="user.first_name"></IriadeTextInput>
        <IriadeTextInput label="Nom" :error-messages="ui.errors.last_name" v-model="user.last_name"></IriadeTextInput>
        <IriadeTextInput label="Adresse e-mail" :error-messages="ui.errors.email" v-model="user.email"></IriadeTextInput>
        <IriadeTextInput label="Numéro de téléphone" :error-messages="ui.errors.phone_number" v-model="user.phone_number"></IriadeTextInput>
        <IriadeTextInput label="Année de naissance" v-model="user.birth_year"></IriadeTextInput>
        <IriadeTextInput
          label="Mot de passe"
          type="password"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="false"
          :error-messages="ui.errors.password"
          v-model="user.password"
        ></IriadeTextInput>

        <v-btn @click="clickFileUploadButton" block class="primary white--text">
          <v-icon left dark>cloud_upload </v-icon>
          <span class="pl-2">Joindre votre ordonnance</span>
        </v-btn>
        <MangoCaption v-if="appointment.file">Fichier joint : {{ appointment.file.name }}</MangoCaption>
        <MangoCaption v-else style="text-align: center">Facultatif </MangoCaption>
        <form ref="fileForm">
          <input type="file" style="display: none" ref="fileInput" @change="handleFile" />
        </form>

        <MangoCaption v-if="!new_slot_required"
          >Attention ! Le rendez-vous sera confirmé uniquement lorsque votre opticien aura pris contact avec vous.
        </MangoCaption>

        <v-btn
          block
          rounded
          class="primary"
          :disabled="!user.first_name || !user.last_name || !user.email || !user.phone_number || !user.password"
          @click="submit"
          :loading="ui.loading"
        >
          Confirmer
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import api from "api";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("application", ["application"]),

    currentAppointmentTypeLabel() {
      let a = this.appointmentTypes.filter((a) => a.id === this.type_id);
      if (a.length) {
        return a[0].label;
      }
      return null;
    },

    firstSlotDayIsToday() {
      return moment(this.ui.slotsDays[0]) <= moment().add(2, "days");
    },

    disabledLastArrow() {
      return moment(this.ui.slotsDays[4]) >= moment().add(21, "days");
    },
  },

  data() {
    return {
      consent_checkbox: false,
      new_slot_required: false,
      new_slot_required_message: null,
      team_id: null,
      type_id: null,
      appointmentTypes: [],
      appointment: {
        team_id: null,
        date: null,
        slot: [],
        type: {},
        file: null,
      },
      appointmentSlots: [],
      teams: [],
      ui: {
        currentDay: null,
        slotsDays: [],
        errors: {},
        loading: false,
        step: 0,
        showConfirmAppointmentModal: false,
        showNewSlotRequiredModal: false,
      },
      user: {
        first_name: null,
        last_name: null,
        email: null,
        phone_number: null,
        password: null,
        birth_year: null,
      },
    };
  },

  filters: {
    //15 minutes supplémentaires invisibles à la fin de chaque rendez-vous
    remove15Minutes(value) {
      if (value) {
        let [hour, minute] = value.split(":");
        return moment().set("hour", hour).set("minute", minute).subtract(15, "minutes").format("HH:mm");
      }
    },
  },

  methods: {
    async getTeams() {
      this.teams = (await api.get("evision/teams")).data;
    },

    tryGetAvailableAppointmentsSlots(event) {
      if (this.team_id) {
        this.getAppointmentTypes(this.team_id);
      }

      if (this.team_id && this.type_id) {
        this.getAvailableAppointmentsSlots(this.team_id, this.type_id);
      }
    },

    async getAvailableAppointmentsSlots(team_id, type_id) {
      this.ui.loading = true;
      this.appointmentSlots = (
        await api.get(`evision/availableSlots`, {
          params: {
            date_start: this.ui.slotsDays[0],
            date_end: this.ui.slotsDays[4],
            team_id,
            type_id,
          },
        })
      ).data;
      this.ui.loading = false;
    },

    getAppointmentTypes(team_id) {
      api.get(`appointments/types/${team_id}`).then((res) => {
        this.appointmentTypes = res.data;
      });
    },

    previousSlotsDays() {
      this.ui.slotsDays = this.ui.slotsDays.map((d) => moment(d).add(-1, "days").format("Y-MM-DD"));
      this.ui.currentDay = null;
      this.getAvailableAppointmentsSlots(this.team_id, this.type_id);
    },

    nextSlotsDays() {
      this.ui.slotsDays = this.ui.slotsDays.map((d) => moment(d).add(1, "days").format("Y-MM-DD"));
      this.ui.currentDay = null;
      this.getAvailableAppointmentsSlots(this.team_id, this.type_id);
    },

    setAppointmentDatetime(day, slot) {
      this.appointment.day = day;
      this.appointment.slot = slot;
    },

    submit() {
      this.ui.loading = true;
      api
        .post("auth/signup", {
          ...this.user,
          ...{
            new_slot_required: this.new_slot_required,
            new_slot_required_message: this.new_slot_required_message,
            day: this.appointment.day,
            slot: this.appointment.slot,
            type_id: this.type_id,
            team_id: this.team_id,
          },
        })
        .then(async (res) => {
          let appointment_id = res.data.appointment_id;
          if (this.appointment.file) {
            let formData = new FormData();
            formData.set("file", this.appointment.file, this.appointment.file.name);
            await api.postFormData(`p/appointments/${appointment_id}/file`, formData);
            document.location.reload();
          }
        })
        .catch((err) => {
          this.ui.errors = err.response.data.errors;
        })
        .then((_) => {
          document.location.reload();
          this.ui.loading = false;
        });
    },

    clickFileUploadButton() {
      this.$refs.fileInput.click();
    },

    handleFile(event) {
      if (event.target && event.target.files && event.target.files[0]) {
        this.appointment.file = event.target.files[0];
      }
    },
  },

  mounted() {
    this.getTeams();

    for (let i = 2; i <= 6; i++) {
      this.ui.slotsDays.push(moment().add(i, "days").endOf("day").format("Y-MM-DD"));
    }
  },
};
</script>

<style lang="scss" type="text/scss">
.EvisionSignupPage {
  .appointment-slot-picker {
    display: flex;
    flex-direction: row;
    justify-content: space-around;

    .column {
      display: flex;
      flex-direction: column;
      width: 50px;
      justify-content: center;
    }
  }
}
</style>
